export default "__VITE_ASSET__$_hfp4us__"